<template>
    <footer class="footer">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <a href="https://ssw.solutions" target=_blank >www.ssw.solutions</a>
                </div>
                <div class="column">
                    <div class="has-text-centered footer__social">
                        <p>{{ $t("watch-us") }}</p>
                        <a href="https://www.linkedin.com/company/1356327/" target="_blank">
                            <i aria-hidden="true" class="fa fa-linkedin-square"></i>
                        </a>
                        <a href="https://twitter.com/PragmaticSsw" target="_blank">
                            <i aria-hidden="true" class="fa fa-twitter-square"></i>
                        </a>
                        <a href="https://www.facebook.com/SSW-Pragmatic-Solutions-198477040912548/" target="_blank">
                            <i aria-hidden="true" class="fa fa-facebook-square"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
}
</script>

<style scoped lang="sass">
@import "@/styles/framework/variables.sass"
.footer
    padding: 3rem 1.5rem 3rem
    &__social,
    &__lang
        height: 100%
        align-items: center
        display: flex
    &__social
        justify-content: flex-end
        +mobile
            justify-content: center
        p
            color: $blue2
            text-transform: uppercase
            margin-bottom: 0
            line-height: 1.5rem
        a
            text-decoration: underline
            margin-left: 1rem
            i
                color: #fff
                font-size: 1.5rem
            svg
                width: 1.5rem
                height: 1.5rem
                path
                    fill: $white
</style>
